import { SET_CURRENT_MOBILE_FILTER, TOGGLE_MOBILE_FILTER, SET_CURRENT_MOBILE_WIDGET, SET_SCROLLED_CLASS } from "../actions/mobileAction";

const mobileReducer = (
    state = {
        showFilters: false,
        currentFilter: {},
        currentOriginalFilter: {},
        currentWidgetTitle: "",
        currentWidgetName: "",
        widgetClass: null,
        isScrolledClass: ""
    },
    action
) => {
    switch (action.type) {
        case SET_CURRENT_MOBILE_WIDGET:
            return { ...state, currentWidgetTitle: action.payload.title, currentWidgetName: action.payload.name };
        case SET_CURRENT_MOBILE_FILTER:
            return { ...state, currentFilter: action.payload[0], currentOriginalFilter: action.payload[1], widgetClass: action.payload[2] };
        case TOGGLE_MOBILE_FILTER:
            return { ...state, showFilters: action.payload };
        case SET_SCROLLED_CLASS:
            return { ...state, isScrolledClass: action.payload };
        default:
            return state;
    }
};

export default mobileReducer;
